<style>
    #zeppelin-container iframe {
        width: 100% !important;
        height: 100% !important;
        border: none;
        text-align: center;
        background-color: Black;
    }
</style>
<template>

    <div class="app flex-row align-items-center">
        <div class="container-fluid" style="position: relative; min-height: 500px;">
            <div class="client-app-inc" style="height:200px" v-if="loading">
                <Loader></Loader>
            </div>
            <div id="zeppelin-container" style="width: 100%; height: 1000px;" v-show="!loading">

            </div>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'Zeppelin',
        metaInfo () {
            return {
            title: 'Zeplin | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
            }
        },
        data: function() {
            return {
                loading: false,
                config: {},
            }
        },
        created: function () {
            this.$forceUpdate();
            this.fetchData();
        },
        mounted() {
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', 'https://static-cdn.betsolutions.com/casino/GameStarter/Prod/gameStarter.min.js?v=' +(Date.now()));
            document.head.appendChild(recaptchaScript);
        },
        methods: {
            fetchData: function() {
                this.loading = true;
                axios.get('/games/zeppelin/launch', { params: { mobile : this.isMobile }})
                    .then((response)=>{
                        if (response.data.status){
                            if (!_.isEmpty(response.data.config)){
                                this.config = response.data.config;
                                this.runGame();
                            }
                        }
                    })
                    .catch((err)=>{
                    });

            },

            runGame: function () {
                setTimeout(t => {
                    Charismatic.Casino.GameStarter.startGame(this.config);
                }, 1000);
                this.loading = false;
            }

        }
    }
</script>
